module.exports = __webpack_public_path__ + "img/arrow.84ba59e3.svg";